import { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { Cargando } from '../Cargando';
import HomeZone from './HomeZone'
import Resgistra from './Resgistra'
import Resumen from './Resumen'
import Preliminar from './Preliminar'
import { useSearchParams } from "react-router-dom"
import 'react-toastify/dist/ReactToastify.css';
import '../css/landingAdmin.css'
import '../css/response.css'
import GestionUsuarios from './GestionUsuarios';
import RegistraServicio from './RegistraServicio';
import CampanasOfertas from './CampanasOfertas';

const AdminZone = ({ setUserSession, userSession }) => {

    const [searchParams] = useSearchParams();
    const origin = searchParams.get('origin');

    const [cargando, setCargando] = useState(false)
    const [viewAdminZone, setViewAdminZone] = useState("")
    const [idProcesamientoScort, setIdProcesamientoScort] = useState("0")
    const [scortService, setScortService] = useState(null)

    useEffect(() => {
        if (origin) {
            if (origin === 'preliminar') {
                setViewAdminZone('VISTA_PRELIMINAR')
            }
        } else {
            setViewAdminZone('HOME')
        }
    }, [])

    const validateRedirect = () => {
        switch (viewAdminZone) {
            case 'HOME':
                return (
                    <HomeZone setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession} />
                )
            case 'RESUMEN':
                return (
                    <Resumen setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        setCargando={setCargando} toast={toast} />
                )
            case 'REGISTRA':
                return (
                    <Resgistra setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        setIdProcesamientoScort={setIdProcesamientoScort} idProcesamientoScort={idProcesamientoScort} setCargando={setCargando}
                        toast={toast} />
                )
            case 'VISTA_PRELIMINAR':
                return (
                    <Preliminar setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        setIdProcesamientoScort={setIdProcesamientoScort} setScortService={setScortService} setCargando={setCargando} toast={toast} />
                )
            case 'GESTION_USUARIOS':
                return (
                    <GestionUsuarios setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        setCargando={setCargando} toast={toast} />
                )
            case 'REGISTRO_SERVICIOS':
                return (
                    <RegistraServicio setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        scortService={scortService} setCargando={setCargando} toast={toast} />
                )
            case 'GESTION_CAMPANAS':
                return (
                    <CampanasOfertas setUserSession={setUserSession} setViewAdminZone={setViewAdminZone} userSession={userSession}
                        setCargando={setCargando} toast={toast} />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <ToastContainer autoClose={4000} hideProgressBar={true} />
            {
                validateRedirect()
            }
            {
                cargando ?
                    <Cargando />
                    :
                    <></>
            }
        </>
    )
}

export default AdminZone